import BlueskyButton from './buttons/bluesky-button'
import CopyUrl from '@/components/sharing/copy-url'
import EmailButton from './buttons/email-button'
import FacebookButton from './buttons/facebook-button'
import MessengerButton from './buttons/messenger-button'
import SharingOptionsMixin from './sharing-options-mixin'
import TwitterButton from './buttons/twitter-button'
import WebShareApiButton from './buttons/web-share-api-button'
import webShareSupportedUtil from '@/utils/web-share-supported'
import WhatsappButton from './buttons/whatsapp-button'

export default {
  components: {
    BlueskyButton, CopyUrl, EmailButton, FacebookButton, MessengerButton, TwitterButton, WebShareApiButton,
    WhatsappButton
  },

  mixins: [SharingOptionsMixin],

  computed: {
    webShareSupported() {
      return webShareSupportedUtil()
    }
  }
}
